import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';

import { NewIcon } from '../../../../components/newIcon/icon';
import { FollowUsContainer, LinkContainer, SocialLinksContainer } from './cardSummary.styled';

const SOCIAL_LINKS = [
  {
    id: 'visa',
    icon: 'Visa',
  },
  {
    id: 'mastercard',
    icon: 'Mastercard',
  },
  {
    id: 'amex',
    icon: 'Amex',
  },
  {
    id: 'apple-pay',
    icon: 'ApplePay',
  },
  {
    id: 'google-pay',
    icon: 'GooglePay',
  },
  {
    id: 'contactless',
    icon: 'Contactless',
  },
];

export function CardSummary() {
  return (
    <FollowUsContainer>
      <WidthContainer noBackground>
        <h2>Accept all major cards and contactless payments</h2>

        <SocialLinksContainer>
          {SOCIAL_LINKS.map((link) => (
            <LinkContainer key={link.id} href={link.link}>
              <NewIcon size="70px" type={link.icon} />
            </LinkContainer>
          ))}
        </SocialLinksContainer>
      </WidthContainer>
    </FollowUsContainer>
  );
}
